import { useState, ReactNode } from "react";
import { Box, Typography, Button, Card, CardContent, useMediaQuery, useTheme } from "@mui/material";
import PhotoGallery from "../photo-gallery/PhotoGallery";
import { AttachmentFile } from "../../models/attachment-file.model";
import { useTranslation } from "react-i18next";

interface Props {
  attachments?: AttachmentFile[];
  title?: string;
  text: ReactNode;
}

export default function ProducerInfoSection({ attachments, title, text }: Props) {
    const [expanded, setExpanded] = useState(false);
    const theme = useTheme();
    const { t } = useTranslation('translation');

    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
    const _attachments: AttachmentFile[] = attachments ?? [];
    const _title: string = title ?? "";

    return (
        <Card
            sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: "center",
                p: 2,
                gap: 3,
                maxWidth: "100%",
                mx: "auto",
                boxShadow: "none",
            }}
        >
            <Box
                sx={{
                    width: { xs: "100%", md: "40%", lg: "100%" },
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <PhotoGallery photos={_attachments} />
            </Box>
            
            <CardContent sx={{ width: { xs: "100%", md: "60%", lg: "100%" } }}>
                <Typography variant="h6" gutterBottom>
                    {_title}
                </Typography>

                <Box
                    sx={{
                        mb: 1,
                        overflow: isSmallScreen ? "hidden" : "visible",
                        display: isSmallScreen ? "-webkit-box" : "block",
                        WebkitLineClamp: isSmallScreen && !expanded ? 5 : "unset",
                        WebkitBoxOrient: "vertical",
                        transition: "all 0.3s ease",
                        "& h1, & h2, & h3, & h4, & h5, & h6": {
                            fontSize: "revert !important",
                            fontWeight: "bold !important",
                        },
                    }}
                >
                    {text}
                </Box>

                {isSmallScreen && (
                    <Button
                        size="small"
                        onClick={() => setExpanded(!expanded)}
                        variant="text"
                        disableRipple
                        disableFocusRipple
                        sx={{ mt: 1, 
                            pl: 0, 
                            fontSize: 10,
                            "&:hover": {
                                backgroundColor: "transparent",
                                boxShadow: "none",
                            },
                            justifyContent: "left"
                        }}
                    >
                        {expanded ? t("SHOW_LESS") : t("SHOW_MORE")}
                    </Button>
                )}
            </CardContent>
        </Card>
    );
}